import { GoabText } from "@abgov/react-components";
import "./BenefitDetails.css";

const BenefitDetails = ({ benefits }) => {
  if (!benefits || benefits.length === 0) {
    return <></>;
  }

  return (
    <>
      <GoabText mb="none">
        <strong>Benefit details</strong>
      </GoabText>
      <ul className="small-squares benefit-details-list">
        {benefits.map((benefit, index) => (
          <li key={index}>
            <GoabText mt="none" mb="none">
              {benefit.publicName || benefit.label}
            </GoabText>
          </li>
        ))}
      </ul>

      <GoabText mb="none">
        <strong>
          Total:{" "}
          {new Intl.NumberFormat("en-CA", {
            style: "currency",
            currency: "CAD",
          }).format(
            benefits.reduce(
              (total, benefit) => total + (Number(benefit.amount) || 0),
              0,
            ),
          )}
        </strong>
      </GoabText>
    </>
  );
};

export default BenefitDetails;
